import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Landmark } from "lucide-react";
import { LogoMark } from "./Logo";

const COLS = [
  {
    title: "Institution",
    links: [
      { label: "About the Academy", to: "/about" },
      { label: "Course Catalog", to: "/programs" },
      { label: "Resources & Library", to: "/resources" },
      { label: "Contact & Admissions", to: "/contact" },
    ],
  },
  {
    title: "Legal & Policy",
    links: [
      { label: "Freedom of Information Act", to: "/resources" },
      { label: "Section 508 Accessibility", to: "/resources" },
      { label: "Privacy Policy", to: "/resources" },
      { label: "Vulnerability Disclosure Policy", to: "/contact" },
    ],
  },
];

const Footer = () => (
  <footer className="relative bg-navy-950 border-t border-gold-500/30 overflow-hidden" data-testid="site-footer">
    <LogoMark className="absolute -right-10 -bottom-16 w-[420px] h-[500px] text-navy-800 opacity-30 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <LogoMark className="w-10 h-12 text-navy-900" />
            <div>
              <div className="font-serif font-bold tracking-[0.08em] text-white text-lg">UNITED STATES</div>
              <div className="font-mono text-[9px] tracking-[0.24em] text-gold-400 mt-1">
                FEDERAL AGENCIES
              </div>
            </div>
          </div>
          <p className="mt-6 text-sm leading-relaxed text-slate-400 max-w-sm">
            A showcase of the front pages of the United States' federal agencies —
            presenting their missions, services and public resources in one place.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 px-3 py-2 border border-gold-500/30 text-[11px] font-mono tracking-wider text-gold-300">
            <Landmark className="w-3.5 h-3.5" /> IN COOPERATION WITH USA.GOV
          </div>
        </div>

        {COLS.map((col) => (
          <div key={col.title} className="lg:col-span-2">
            <h3 className="font-mono text-[11px] uppercase tracking-[0.24em] text-gold-400">
              {col.title}
            </h3>
            <ul className="mt-5 space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="text-sm text-slate-300 link-underline transition-colors duration-200 hover:text-gold-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="lg:col-span-3">
          <h3 className="font-mono text-[11px] uppercase tracking-[0.24em] text-gold-400">
            Headquarters
          </h3>
          <ul className="mt-5 space-y-4 text-sm text-slate-300">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" />
              <span>1200 Constitution Row NW<br />Federal Triangle, Washington, D.C. 20004</span>
            </li>
            <li className="flex gap-3 items-center">
              <Mail className="w-4 h-4 text-gold-500 shrink-0" />
              <span>info@usa.gov</span>
            </li>
            <li className="flex gap-3 items-center">
              <Phone className="w-4 h-4 text-gold-500 shrink-0" />
              <span>USA.gov: 1-844-872-4681</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-xs text-slate-500 max-w-xl leading-relaxed">
          © 2026 United States Federal Agencies Directory. Content is provided for
          informational and educational purposes. Pursuant to federal policy, all
          materials are released for public benefit.
        </p>
        <p className="font-mono text-[10px] tracking-[0.2em] text-gold-500/80 whitespace-nowrap">
          WASHINGTON, D.C. · USA.GOV
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
